export const GET_USER_FLAGS = 'GET_USER_FLAGS';
export const GET_USER_FLAGS_DONE = 'GET_USER_FLAGS_DONE';
export const GET_USER_FLAGS_ERROR = 'GET_USER_FLAGS_ERROR';
export const HERO_ONLINE = 'HERO_ONLINE';
//# sourceMappingURL=actionTypes.js.map